import { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import API from 'core/Api';
import IResponseData from 'types/api';
import MainLayout from 'components/main-layout/MainLayout';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import ElementsList from 'components/elements/components/List';
import EditForm from './EditForm';
import { ISegment } from '../types';

interface IProps {
  segmentsEntityName: string;
  segmentsEndpoint: string;
  elementsEntityName: string;
  elementsEndpoint: string;
  segmentFilter: string;
}

const Edit: FC<IProps> = ({
  segmentsEntityName,
  segmentsEndpoint,
  elementsEntityName,
  elementsEndpoint,
  segmentFilter,
}) => {
  const { id } = useParams<{ id: string | undefined }>();
  const { client } = useActiveClientContext();
  const { isLoading, error, data } = useQuery<ISegment, Error>(
    [buildClientEntity(segmentsEntityName, client), { id }],
    (): Promise<ISegment> =>
      API.get<IResponseData<ISegment>>(`${segmentsEndpoint}?id=${id}`).then(res => res.data?.items[0])
  );

  return (
    <MainLayout
      title="Редактиране на сегмент и неговите елементи"
      isLoading={isLoading}
      error={error}
    >
      {data && (
        <>
          <h3 className="h5 mb-4">Информация за сегмента</h3>
          <hr className="mb-5" />
          <EditForm
            segmentsEntityName={segmentsEntityName}
            segmentsEndpoint={segmentsEndpoint}
            segment={data}
          />
        </>
      )}
      <h3 className="h5 mt-5 mb-4">Елементи на сегмента</h3>
      <hr className="mb-5" />
      <ElementsList
        entityName={elementsEntityName}
        entityEndpoint={elementsEndpoint}
        segmentFilter={segmentFilter}
      />
    </MainLayout>
  );
};

export default Edit;
